import { render, staticRenderFns } from "./FieldsetGroup.vue?vue&type=template&id=745339cf&scoped=true&"
import script from "./FieldsetGroup.vue?vue&type=script&lang=js&"
export * from "./FieldsetGroup.vue?vue&type=script&lang=js&"
import style0 from "./FieldsetGroup.vue?vue&type=style&index=0&id=745339cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745339cf",
  null
  
)

export default component.exports